var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('language-tap-bar', {
    attrs: {
      "data-test": "localizationControllerTapBar",
      "language-code": _vm.language.code,
      "inverted-color": _vm.invertedColor
    },
    on: {
      "click": _vm.handleShown
    }
  }), _c('languages-list-modal', {
    attrs: {
      "data-test": "localizationControllerModal",
      "languages": _vm.formattedLanguages
    },
    on: {
      "change-localization": _vm.handleChange
    },
    model: {
      value: _vm.isShownLanguagesList,
      callback: function callback($$v) {
        _vm.isShownLanguagesList = $$v;
      },
      expression: "isShownLanguagesList"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }